import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guest-content',
  templateUrl: './guest-content.component.html',
  styleUrls: ['./guest-content.component.scss']
})
export class GuestContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
